import React from 'react'
import { useQuill } from 'react-quilljs';
import 'quill/dist/quill.snow.css'; 
function TextQill({text,textDir , setText ,textHolder}) {

    const placeholder = textHolder;
    const theme = 'snow';
    const modules = {
        toolbar: [
          ['bold', 'italic', 'underline', 'strike' ,],
          [{ align: [] }],
          [{ list: 'ordered'}, { list: 'bullet' }],
          [{ indent: '-1'}, { indent: '+1' }],
         
        ],
      };
      const { quill, quillRef } = useQuill({placeholder,theme,modules});
    React.useEffect(() => {
        if (quill) {
            quill.on('text-change', (delta, oldDelta, source) => {
          
            
              setText(quillRef.current.firstChild.innerHTML);

            });
          }
        }, [quill]);
      

    
        
    
  return (
   
    <div  style={{ width: "100%",marginBlock:15,height: 300 }}>
    <div  ref={quillRef} />
  </div>
  )
}

export default TextQill